import Card from "../Card";
import Typography from "../Typography";
import IconCard from "./IconCard";

export default function StepItem({ icon, descricao, className, color }) {
    return (
        <div className={`relative flex ${className} rounded-full`}>
            <div className="absolute flex flex-col items-center w-[max-content] -bottom-[50px] absolute start-0 -translate-x-1/2">
                <IconCard className={`mb-4 ${color}`}>
                    {icon}
                </IconCard>
                <Typography component="tbody2-step" className={color}>{descricao}</Typography>
            </div>
        </div>
    )
}